import "./DashboardReportingPlaceholder.css";

export default function DashboardReportingPlaceholder({ loading = false }) {
  return (
    <div className="dashboard-reporting-placeholder" aria-busy={loading}
      aria-label={loading ? "Loading reporting" : "Reporting not available"}>
      {loading ? <span className="dashboard-reporting-placeholder-line" aria-hidden="true" /> : <span aria-hidden="true">—</span>}
    </div>
  );
}
